import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import {
  ChatBubbleLeftRightIcon,
  ArrowLeftIcon,
} from '@heroicons/react/24/outline';
import { useAuth } from '../contexts/AuthContext';
import AdminFeedbackSection from '../components/AdminFeedbackSection';

const AdminFeedbackPage: React.FC = () => {
  const { user } = useAuth();
  if (!user) return <Navigate to="/" replace />;
  if (!user.is_super_admin) return <Navigate to="/" replace />;

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-6 flex items-start gap-3">
          <Link
            to="/admin"
            className="mt-1 inline-flex items-center justify-center rounded-md p-1.5 text-gray-500 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-800"
            title="Back to Admin Panel"
          >
            <ArrowLeftIcon className="h-5 w-5" />
          </Link>
          <div>
            <div className="flex items-center gap-2">
              <ChatBubbleLeftRightIcon className="h-6 w-6 text-brand-600 dark:text-brand-400" />
              <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Customer Feedback</h1>
            </div>
            <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">
              Triage in-app feedback, preview the source PDF, mark items as solved, filter by account or rating.
            </p>
          </div>
        </div>

        <AdminFeedbackSection />
      </div>
    </div>
  );
};

export default AdminFeedbackPage;
